<template>
    <div :class="alertClass" role="alert" v-show="!dismissed">
        <div class="icon" v-if="icon || iconText">
            <span :class="`mdi mdi-${icon}`" v-if="icon"></span>
            <template v-if="iconText">{{ iconText }}</template>
        </div>
        <div class="message">
            <button class="close" type="button" @click="dismissed=true" v-if="dismissible"><span class="mdi mdi-close"></span></button>
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            center: Boolean,
            contrast: Boolean,
            dismissible: Boolean,
            simple: Boolean,
            border: Boolean,
            iconBackground: Boolean,
            iconColored: Boolean,
            color: String,
            icon: String,
            iconText: String,
        },

        data: () => ({
            dismissed: false,
        }),

        computed: {
            alertClass: vm => ({
                alert: true,
                'alert-contrast': vm.contrast,
                'alert-dismissible': vm.dismissible,
                'alert-simple': vm.simple,
                [`alert-${vm.color}`]: vm.color,
                'alert-icon': vm.border || vm.iconColored || vm.iconBackground,
                'alert-icon-border': vm.border,
                'alert-icon-colored': vm.iconColored,
                'splash-container': vm.center,
            }),
        },
    };
</script>
